module.exports = __webpack_public_path__ + "img/login-banner-logo-32.4e588d41.png";